import { Controller } from "stimulus"

export default class extends Controller {
  static values = { stagger: Number, threshold: Number, repeat: Boolean }

  connect() {
    const items = this.element.matches(".appear")
      ? [ this.element ]
      : Array.from(this.element.querySelectorAll(".appear"))
    if (!items.length) return

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      items.forEach(el => el.classList.add("appear--in"))
      return
    }

    const threshold = this.hasThresholdValue ? this.thresholdValue : 0.1
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      threshold: threshold,
      rootMargin: "0px 0px -8% 0px"
    })

    items.forEach((el, index) => {
      if (this.staggerValue) {
        el.style.setProperty("--appear-delay", `${index * this.staggerValue}ms`)
      }
      this.observer.observe(el)
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("appear--in")
        if (!this.repeatValue) this.observer.unobserve(entry.target)
      } else if (this.repeatValue) {
        entry.target.classList.remove("appear--in")
      }
    })
  }
}
